import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Validators, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
//import { ActivatedRoute, Router } from '@angular/router';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-user-registration',
  templateUrl: './ph-bhp-user-registration.component.html',
  styleUrls: ['./ph-bhp-user-registration.component.css']
})
export class PhBhpUserRegistrationComponent implements OnInit {


  userSigninFormBasicInfo: UntypedFormGroup;
  userSigninFormInstitutionInfo: UntypedFormGroup;
  userSignin: any = {};
  @Output() childData = new EventEmitter();
  translationKeys: typeof TranslationKeys = TranslationKeys;
  
  constructor() { }

  ngOnInit() {
    this.userSigninFormBasicInfo = new UntypedFormGroup({
      inputName: new UntypedFormControl('', Validators.compose([Validators.required])),
      inputUserName: new UntypedFormControl('', Validators.compose([Validators.required])),
      inputEmail: new UntypedFormControl('', Validators.compose([Validators.required]))
    });

    this.userSigninFormInstitutionInfo = new UntypedFormGroup({
      institutionName: new UntypedFormControl('', Validators.compose([Validators.required])),
      InputAddress1: new UntypedFormControl('', Validators.compose([Validators.required])),
      InputAddress2: new UntypedFormControl('', Validators.compose([Validators.required])),
      inputCity: new UntypedFormControl('', Validators.compose([Validators.required])),
      InputState: new UntypedFormControl('', Validators.compose([Validators.required])),
      InputZipCode: new UntypedFormControl('', Validators.compose([Validators.required])),
      inputCountry:  new UntypedFormControl('', Validators.compose([Validators.required])),
      InputPhone: new UntypedFormControl('', Validators.compose([Validators.required])),
      InputFax: new UntypedFormControl('', Validators.compose([Validators.required])),
      InputPackage: new UntypedFormControl('', Validators.compose([Validators.required]))

    });
  }

      saveUser(isSaveClicked) {
      //  if (!this.userSigninFormBasicInfo.valid && !this.userSigninFormInstitutionInfo.valid && isSaveClicked) {
      //  return false;
      //  }
      //  if (isSaveClicked) {
      //  this.userSignin = {
      //  basicInfo : this.userSigninFormBasicInfo.value,
      //  institutionInfo : this.userSigninFormInstitutionInfo.value
      //  };
      //  } else {
      //  this.userSigninFormBasicInfo.reset();
      //  this.userSigninFormInstitutionInfo.reset();
      //  }
        //this.router.navigate(['login']);
        this.childData.emit(isSaveClicked);
        }




}
